import React from 'react'

import { NotificationGroup } from '~/components/elements/NotificationGroup'
import { Auth0Provider } from '~/components/providers/Auth0Provider'
import { I18nextProvider } from '~/components/providers/I18nextProvider'
import { IntlProvider } from '~/components/providers/IntlProvider'
import { LocalizationProvider } from '~/components/providers/LocalizationProvider'
import { TanstackProvider } from '~/components/providers/TanstackProvider'
import { Root } from '~/routes/Root'

// LocalizationProvider 内でuseTranslationを使っているが、
// マウント時にはまだ初期化が済んでおらず使えないため初期化を待つためにSuspenseでラップしてやる必要がある
export const App = () => (
  <Auth0Provider>
    <TanstackProvider>
      <I18nextProvider>
        {({ language }) => (
          <IntlProvider language={language}>
            <React.Suspense>
              <LocalizationProvider>
                <Root />

                <NotificationGroup />
              </LocalizationProvider>
            </React.Suspense>
          </IntlProvider>
        )}
      </I18nextProvider>
    </TanstackProvider>
  </Auth0Provider>
)
